import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { LogIn, ArrowLeft } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';
import FixedFooter from '@/components/common/FixedFooter';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/admin/login`, {
        email,
        password,
      });

      localStorage.setItem('admin-token', response.data.access_token);
      toast.success('Login successful!');
      navigate('/admin/dashboard');
    } catch (error) {
      console.error('Login error:', error);
      toast.error(error.response?.data?.detail || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col justify-between px-7 relative pb-7">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(/images/bwp-bg.jpg)',
          filter: 'brightness(1.1) contrast(1.05) saturate(1.1)',
        }}
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-white bg-opacity-60" />

      {/* Centered Login Card */}
      <div className="relative z-10 flex-1 flex items-center justify-center">
        <div className="w-full max-w-md">
          <button
            onClick={() => navigate('/')}
            className="mb-6 flex items-center gap-2 text-burgundy hover:opacity-80"
            style={{ color: 'var(--burgundy)' }}
            data-testid="back-button"
          >
            <ArrowLeft size={20} />
            <span>Back to Home</span>
          </button>

          <div className="glass-burgundy rounded-3xl p-8 md:p-12 shadow-2xl">
            <div className="text-center mb-8">
              <h1
                className="text-3xl md:text-4xl mb-2"
                style={{ color: 'var(--burgundy)' }}
              >
                Admin Login
              </h1>
              <p
                className="text-sm"
                style={{ color: 'var(--charcoal)', opacity: 0.8 }}
              >
                Manage your restaurant menu
              </p>
            </div>

            <form onSubmit={handleLogin} className="space-y-6">
              <div>
                <label
                  className="block text-sm font-medium mb-2"
                  style={{ color: 'var(--charcoal)' }}
                >
                  Email Address
                </label>
                <Input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="admin@tejvivaan.com"
                  required
                  className="w-full glass px-4 py-3 rounded-lg"
                  data-testid="email-input"
                />
              </div>

              <div>
                <label
                  className="block text-sm font-medium mb-2"
                  style={{ color: 'var(--charcoal)' }}
                >
                  Password
                </label>
                <Input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  required
                  className="w-full glass px-4 py-3 rounded-lg"
                  data-testid="password-input"
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full btn-primary py-3 justify-center"
                data-testid="login-button"
              >
                {loading ? (
                  <span>Logging in...</span>
                ) : (
                  <>
                    <LogIn size={20} />
                    <span>Login</span>
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Powered by Absolin — now visible & at the bottom */}
      <div className="relative z-10">
        <FixedFooter />
      </div>
    </div>
  );
};

export default AdminLoginPage;
